import { cn } from '../../lib/cn';

export interface AvatarProps {
  name: string;
  photoUrl?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const second = parts.length > 1 ? (parts[1]?.[0] ?? '') : '';
  return (first + second).toUpperCase();
}

const SIZES = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
};

/**
 * Avatar for a contact/dialog. Shows `photoUrl` when present (§U1 row spec), otherwise
 * falls back to initials. `photoUrl` is filled in by the `contact.enrich` job (U3.5) —
 * a freshly-imported contact may still show initials until that job runs.
 */
export function Avatar({ name, photoUrl, size = 'sm', className }: AvatarProps) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        loading="lazy"
        className={cn('shrink-0 rounded-full object-cover', SIZES[size], className)}
      />
    );
  }
  return (
    <div
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-primary/15 font-semibold text-primary',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </div>
  );
}
